import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import TextButton from 'LuxKit/Button/TextButton'
import type { TripItineraryData } from 'tripPlanner/api/types'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import type { DrawerExperienceSearchTile } from './ExperienceListingDrawer/ExperienceDetailView'
import ExperienceSearchResults from './ExperienceListingDrawer/ExperienceSearchResults'

interface Props {
  experiences: Array<DrawerExperienceSearchTile>
  isLoading: boolean
  isError: boolean
  onRetry: () => void
  onSelectExperience: (experience: DrawerExperienceSearchTile) => void
  placeName: string
  titleInContent?: string
  subtitleInContent?: string
  browseAllResultsUrl: string
  itineraryData?: TripItineraryData
  onSendMessage?: (message: string) => void
  getTrackingOffer?: (offerId: string) => App.ExperienceOffer | undefined
}

function ThingsToDoTab({
  experiences,
  isLoading,
  isError,
  onRetry,
  onSelectExperience,
  placeName,
  titleInContent,
  subtitleInContent,
  browseAllResultsUrl,
  itineraryData,
  onSendMessage,
  getTrackingOffer,
}: Props) {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={24}>
      {(titleInContent || subtitleInContent) && (
        <Group direction="vertical" gap={4}>
          {titleInContent && (
            <Heading variant="heading3">
              {titleInContent}
            </Heading>
          )}
          {subtitleInContent && (
            <BodyText variant="large">{subtitleInContent}</BodyText>
          )}
        </Group>
      )}
      {isError && !isLoading ? (
        <Group
          direction="vertical"
          gap={8}
          horizontalAlign="center"
          verticalAlign="center"
        >
          <BodyText variant="medium" weight="bold">
            {intl.formatMessage({
              id: '_prz987A-9P1umJt9l9D',
              defaultMessage: 'Failed to load experiences.',
              description:
                'Error message shown when experience search results fail to load in the drawer.',
            })}
          </BodyText>
          <TextButton kind="secondary" size="small" onClick={onRetry}>
            {intl.formatMessage({
              id: 'MUzm0X4vh_i2I0FMkGBi',
              defaultMessage: 'Try again',
              description:
                'Button label to retry loading experience search results in the drawer.',
            })}
          </TextButton>
        </Group>
      ) : (
        <ExperienceSearchResults
          experiences={experiences}
          isLoading={isLoading}
          onSelectExperience={onSelectExperience}
          placeName={placeName}
          browseAllResultsUrl={browseAllResultsUrl}
          itineraryData={itineraryData}
          onSendMessage={onSendMessage}
          getTrackingOffer={getTrackingOffer}
        />
      )}
    </Group>
  )
}

export default ThingsToDoTab
